import apiHandler from '../../../api/core/apiHandler';
import {
  CustomResponse,
  RestaurantSettingsDTO,
  RestaurantSettingsDTOMap,
  RestaurantSettingsSectionKey,
  RestaurantSettingsUpdateDTOMap,
} from './RestaurantSettingsTypes';

const restaurantSettingsApi = apiHandler('restaurant/settings/branches');

const RestaurantSettingsService = {
  getByBranch: async (
    branchId: number
  ): Promise<CustomResponse<RestaurantSettingsDTO>> => {
    const response = await restaurantSettingsApi.fetchCustom(`/${branchId}`);
    return response.data;
  },

  updateSection: async <K extends RestaurantSettingsSectionKey>(
    branchId: number,
    section: K,
    data: RestaurantSettingsUpdateDTOMap[K]
  ): Promise<CustomResponse<RestaurantSettingsDTOMap[K]>> => {
    const response = await restaurantSettingsApi.modifyCustom(
      `/${branchId}/${section}`,
      data
    );
    return response.data;
  },
};

export default RestaurantSettingsService;

